import { render, staticRenderFns } from "./UpdateLog.vue?vue&type=template&id=112f8abe&"
import script from "./UpdateLog.vue?vue&type=script&lang=js&"
export * from "./UpdateLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports